import { useContext, useEffect, useState } from "react";
import { getBatch, getSortedCollection } from "sprint-common-web";

import { DeliveryEndpointContext } from "../context/DeliveryEndpointContext";
import { DeliveryEndpointItem } from "./DeliveryEndpointItem";
import { DeliveryEndpointListingFilters } from "./useDeliveryEndpointListingFilters";

export const useDeliveryEndpointListing = (filters: DeliveryEndpointListingFilters) => {
    const [items, setItems] = useState<DeliveryEndpointItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { deliveryEndpointItems, isLoading } = useContext(DeliveryEndpointContext);

    useEffect(() => {
        if (deliveryEndpointItems.length) {
            getData();
        }
    }, [deliveryEndpointItems, filters.page, filters.pageSize, filters.sortBy, filters.sortOrder]);

    const getData = (): void => {
        const sortedItems = getSortedCollection(deliveryEndpointItems, filters.sortBy, filters.sortOrder);
        const itemsToDisplay = getBatch(sortedItems, filters.pageSize, filters.page);

        setTotalItems(sortedItems.length);
        setItems(itemsToDisplay);
    };

    return {
        items,
        totalItems,
        isLoading,
        getData
    };
};
